import React from 'react'
import ModalBody from "../modalbody";

const BillModal = ({base_min_km, base_fare, extra_km_fare, cgst_amount, sgst_amount, total_amount, coupon_amount, pay_amount,paid_amount , balance}) => {
    return (
        <ModalBody heading="">
            <div style={{minHeight: `100px`}}>
                <div className="flex-center">
                    <h3 className="f-600 header-underline text-center">Price Details</h3>
                </div>
                <div className="flex-center flex-column">
                    <table className="table table-bordered table-condensed table-responsive table-striped f-18">
                        <tbody>
                            <tr>
                                <td>Base fare for {base_min_km} km</td>
                                <td className="text-right">₹{base_fare}</td>
                            </tr>
                            <tr>
                                <td>Additional km charge</td>   
                                <td className="text-right">₹{extra_km_fare}</td>
                            </tr>
                            <tr>
                                <td>CGST</td>
                                <td className="text-right">₹{cgst_amount}</td>
                            </tr>
                            <tr>
                                <td>SGST</td>
                                <td className="text-right">₹{sgst_amount}</td>
                            </tr>
                            <tr>
                                <td>Total Amount</td>
                                <td className="text-right"><b>₹{total_amount}</b></td>
                            </tr>
                            <tr>
                                <td>Discount</td>
                                <td className="text-right"> - ₹{coupon_amount}</td>
                            </tr>
                            <tr>
                                <td>Pay Amount</td>
                                <td className="text-right"><b>₹{pay_amount}</b></td>
                            </tr>
                            <tr>
                                <td>Paid Amount</td>
                                <td className="text-right"><b> - ₹{paid_amount}</b></td>
                            </tr>
                            <tr>
                                <td>Balance Amount</td>
                                <td className="text-right"><b>₹{balance}</b></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ModalBody>
    )
}

export default BillModal
